import styled from "styled-components";
import { BodyDefault, BodyMedium, BodySmall, HeadLine1, VerySmall } from "../../../../../components/typography/styled";

type ActiveProp = {
  active?: boolean;
}


export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`
export const BodyForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: min(100%, 830px);
  margin-top: 20px;
  min-width: 0;
`
export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  margin-bottom: 20px;
  margin-top: 20px;
`

export const InputsWrapper = styled.div`
  display:flex;
  flex-direction: column;
  width: min(360px, 100%);
  justify-content: space-between;
  gap:20px;
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  min-width: 0;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`

export const FieldLabel = styled(BodyMedium)`
  color: ${({theme}) => theme.palette[850]};
`

export const FieldError = styled(BodyDefault)`
  color: ${({theme}) => theme.errors[600]};
  margin-top: -14px;

  &:first-letter {
    text-transform: uppercase;
  }
`

export const SourceControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 100%;
`

export const RequiredMark = styled.span`
  color: ${({theme}) => theme.accent[100]};
`

export const FlavorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 208px));
  gap: 12px;
  width: min(100%, 648px);

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 208px));
    width: min(100%, 428px);
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    width: 100%;
  }
`

export const FlavorCard = styled.button<ActiveProp>`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 208px;
  height: 91px;
  padding: 14px;
  background: ${({theme}) => theme.palette[10]};
  border: ${({theme, active}) => active ? `1px solid ${theme.accent[100]}` : `1px solid ${theme.grey[350]}`};
  border-radius: ${({theme}) => theme.radius.control};
  outline: none;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: ${({theme}) => theme.accent[100]};
  }

  &:focus-visible {
    border-color: ${({theme}) => theme.accent[100]};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }

  &[aria-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[aria-disabled='true']:hover {
    border-color: ${({theme}) => theme.grey[350]};
  }

  @media (max-width: 720px) {
    width: 100%;
  }
`

export const SelectedCheck = styled.span`
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background-color: ${({theme}) => theme.accent[100]};
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M3.5 8L6.5 11L12.5 5' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  border-radius: ${({theme}) => theme.radius.xs};
`

export const FlavorName = styled(BodyMedium)`
  color: ${({theme}) => theme.palette[850]};
  text-align: center;
`

export const FlavorDivider = styled.div`
  width: 158px;
  margin: 8px 0;
  border-bottom: ${({theme}) => `1px solid ${theme.grey[350]}`};
`

export const FlavorMeta = styled(VerySmall)`
  color: ${({theme}) => theme.palette[700]};
  text-align: center;
  white-space: nowrap;
`

export const SourceTabs = styled.div`
  display: flex;
  width: fit-content;
  height: 40px;
  box-sizing: border-box;
  padding: 2px;
  background: ${({theme}) => theme.grey[300]};
  border-radius: ${({theme}) => theme.radius.control};

  @media (max-width: 768px) {
    max-width: 100%;
    overflow-x: auto;
  }
`

export const SourceTab = styled.button<ActiveProp>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 8px 23px;
  background: ${({theme, active}) => active ? theme.isDark ? theme.palette[600] : theme.palette[10] : 'transparent'};
  border: none;
  border-radius: ${({theme}) => theme.radius.control};
  box-shadow: ${({theme, active}) => active ? theme.shadows.control : 'none'};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({theme, active}) => active ? theme.accent[100] : theme.palette[650]};
  cursor: pointer;
  outline: none;
  white-space: nowrap;
  transition: 0.3s all ease-in-out;

  &:focus-visible {
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const OsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: min(100%, 784px);
`

export const OsCard = styled.button<ActiveProp>`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 84px;
  height: 84px;
  padding: 12px 18px;
  background: ${({theme}) => theme.palette[10]};
  border: ${({theme, active}) => active ? `1px solid ${theme.accent[100]}` : `1px solid ${theme.grey[350]}`};
  border-radius: ${({theme}) => theme.radius.control};
  outline: none;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: ${({theme}) => theme.accent[100]};
  }

  &:focus-visible {
    border-color: ${({theme}) => theme.accent[100]};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const OsIcon = styled.img`
  width: 20px;
  height: 20px;
`

export const OsName = styled(BodyDefault)`
  color: ${({theme}) => theme.palette[850]};
  white-space: nowrap;
`

export const HiddenMarketplace = styled.div`
  display: none;
`

export const MarketplaceMockGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 208px);
  gap: 12px;
  width: 648px;
  max-width: 100%;
`

export const MarketplaceMockCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
  width: 208px;
  height: 91px;
  padding: 14px;
  background: ${({theme}) => theme.palette[10]};
  border: ${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius: ${({theme}) => theme.radius.control};
`

export const ControlsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
`

export const ButtonRow = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  flex-wrap: wrap;
`


export const PropContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  padding: 3px 4px;
  height:21px;
  background-color: ${({theme}) => theme.palette[300]};
  border-radius: 4px;
  align-items: center;
`
export const Prop = styled(VerySmall)`
  color:${({theme}) => theme.palette[850]};
`
export const PasswordWrapper = styled.div`
  position: relative;
  width: min(360px, 100%);
`

export const WindowsAlertContainer = styled.div`
  background-color: ${({theme}) => theme.palette[200]};
  display: flex;
  flex-direction: column;
  padding:15px;
  gap:10px;
  border-radius:8px;
`

export const DocLinkContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 10px;
  /* width: 330px;
  height: 32px; */
  background: ${({theme}) => theme.base.white};
  border:  1px solid ${({theme}) => theme.palette[350]};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  &:hover{
    cursor: pointer;
  }
`
export const LinkStyled = styled(BodySmall)`
  color:${({theme}) => theme.primary[600]};
`
export const ImgDoc = styled.img`
  width:24px;
  height:24px;

`

type ErrorProp = {
  isError?:boolean
}
export const ErrorContainer = styled.div<ErrorProp>`
  display: ${({isError}) => isError ? 'flex' : 'none'};
  width: 100%;
  /* height: 30px; */
  background: #FFE6E6;
  border-radius: 4px;
  flex-direction: row;
  box-sizing: border-box;
  /* justify-content: space-between; */
  align-items:flex-start;
  padding: 8px 10px;
  margin-top:18px;
`

export const ErrorText = styled(BodySmall)`
  color: #FF3D3D;
  margin-left:6px;
`

export const WarningBlock = styled.div`
  display: flex;
  box-sizing: border-box;
  align-items: flex-start;
  padding:6px 8px;
  gap:6px;
  background-color: #FFF5D2;
  /* height: 72px; */
  width: 100%;
  border-radius: 4px;
  /* margin-bottom:10px; */
`

export const WarningText = styled(BodyDefault)`
  color:${({theme}) => theme.isDark ? theme.base.white : theme.base.black};
`
